import Beranda from "../../../../../components/categories/siakad/laporan_adab/beranda/Home";
export default function Home() {
  
  return (
    <Beranda />
  );
}
